<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ pageTitle$ | async }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'USERS.TITLE' | translate"
        [previousPageUrl]="'/bc-admin'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <button mat-stroked-button color="secondary" [routerLink]="'/business/search'">
        {{ 'MANAGE_ACCOUNTS.CREATE_ACCOUNT' | translate }}
      </button>
      <ng-container *ngIf="user$ | async as user">
        <a mat-flat-button color="primary" href="{{ impersonationUrl$ | async }}">
          {{ 'COMMON.ACTION_LABELS.IMPERSONATE' | translate }}
        </a>
      </ng-container>
      <app-tertiary-dropdown-button
        *ngIf="headerButtons$ | async as headerButtons"
        [tertiaryButtons]="headerButtons"
      ></app-tertiary-dropdown-button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [maxWidth]="1160">
    <router-outlet></router-outlet>
  </glxy-page-wrapper>
</glxy-page>
